import {makeObservable} from "mobx";
import BillingTransactionStore from "./billing-transaction-store";
import {rootContainer, TYPE} from "../../../services/container/root";
import PagedDataStore, {IFetchListArgs, IPagedData} from "../../../stores/abstract-paged-data-store";
import BillingService from "../../../services/api/billing-service";

class PlanChargesBillingTableStore extends PagedDataStore<BillingTransactionStore> {
    constructor() {
        super();
        
        // TODO: find out why this cannot be defined in class
        this._sortBy = 'period_start';
        this._sortDir = 'desc';

        this.perPage = 20;
        makeObservable(this);
    }

    protected get service(): BillingService {
        return rootContainer.get<BillingService>(TYPE.BillingService);
    }

    protected async fetchList(args: IFetchListArgs): Promise<IPagedData<BillingTransactionStore>> {
        const result = await this.service.fetchList({
            ...args,
            search_store_name: ''
        });

        return {
            ...result,
            data: result.data.map(billingTransaction => {
                return new BillingTransactionStore(billingTransaction);
            })
        };
    }
}

const planChargesBillingTableStore = new PlanChargesBillingTableStore();
export default planChargesBillingTableStore;
